export function handleNajaForms(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[naja-form]');
	} else {
		var $cont = $(selector + ' [naja-form]');
	}

	$cont.each(function (idx) {
		let $form = $(this);

		$form.find('[naja-submit]').on('click', function (event) {
			submit($form);
		});

	});

}

function submit($form) {
	console.log('submitted');

	var data = new FormData();
	data.append('_do', $form.attr('naja-do'));

	$form.find('input,select,textarea').each(function(i) {
		let $el = $(this);
		if ($el.is("textarea") || $el.is('select') || $el.attr('type') === 'text') {
			data.append($el.attr('name'), $el.val());
		} else if ($el.attr('type') === 'checkbox' || $el.attr('type') === 'checkbox') {
			if ($el.prop('checked')) {
				data.append($el.attr('name'), $el.val());
			}
		}

	});

	najaGlobal.makeRequest($form.attr('naja-method').toString().toUpperCase(), $form.attr('naja-action'), data);
}
